import { FormattedMessage } from 'react-intl';

import { RateError } from './error';
import style from './style.module.less';
import { ComponentStates } from '../../../enums/component-states';
import { useFulfillmentPlannerContext } from '../../../fulfillment-planner/context';
import { CostReviewLink, getShouldDisableCostReview } from '../../../fulfillment-planner/cost-review-link';
import { useIsTikTokShippingOrder } from '../../../fulfillment-planner/hooks/use-is-tiktok-shipping-order';
import LabeledRow from '../../../fulfillment-planner/labeled-row';
import messages from '../../../fulfillment-planner/labeled-row/messages';
import RateAmount from '../../../fulfillment-planner/rate/rate-amount';
import RateRefresherContainer from '../../../fulfillment-planner/rate/rate-refresher';

const renderRate = (fulfillmentPlanId) => (
  <>
    <RateAmount />
    <RateRefresherContainer fulfillmentPlanId={fulfillmentPlanId} />
  </>
);

const renderError = () => <RateError />;

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @returns {React.JSX.Element}
 */
export const RateContainer = ({ fulfillmentPlanId }) => {
  const { isRating, rateErrors, labelCreationErrors, isCreatingLabel, didLabelCreationFail, totalCost, uiRestrictions } =
    useFulfillmentPlannerContext();
  const isTikTokShipping = useIsTikTokShippingOrder(fulfillmentPlanId);

  const errorMessages = didLabelCreationFail ? labelCreationErrors : rateErrors;
  const hasError = errorMessages?.length > 0;
  const showRateError = hasError && !isRating && !isCreatingLabel;

  const rateProvided = uiRestrictions?.rateSummary?.componentState === ComponentStates.Provided && !isTikTokShipping;
  const isCostReviewDisabled = getShouldDisableCostReview({
    isRating,
    hasRateErrors: Boolean(rateErrors?.length),
    hasRate: Boolean(totalCost?.value),
    hasProvidedRate: rateProvided,
  });

  return (
    <LabeledRow className={style['rate-row-container']} label={<FormattedMessage {...messages.rate} />} labelClassName={style.label}>
      <div className={style.container}>{showRateError ? renderError() : renderRate(fulfillmentPlanId)}</div>
      <CostReviewLink fulfillmentPlanIds={[fulfillmentPlanId]} linkDisabled={isCostReviewDisabled} />
    </LabeledRow>
  );
};
